import React, {FC, ReactNode, useCallback, useContext, useMemo} from 'react';
import {PickupModalContext} from 'modules/products/context/PickupModal';
import {ProductPageContext} from 'modules/product-card/context';
import {IWineShop} from 'modules/wineshops-list/models';

interface IProps {
    children: ReactNode;
}

export const ProductPickUpModalProvider: FC<IProps> = ({children}) => {
    const {canBuy, canReserve, onSelectShop, wineshopsForTodayWithStock: wineShopList} = useContext(ProductPageContext);

    const handleSelectShop = useCallback(
        (wineshop: IWineShop) => {
            onSelectShop?.(wineshop);
        },
        [onSelectShop],
    );

    const value = useMemo(() => {
        return {
            isMapButtonShow: Boolean(canBuy || canReserve),
            mapButtonTitle: 'Заберу отсюда',
            onSelectShop: handleSelectShop,
            wineShopList,
        };
    }, [canBuy, canReserve, handleSelectShop, wineShopList]);

    return <PickupModalContext.Provider value={value}>{children}</PickupModalContext.Provider>;
};
